<template>
  <div class="review-extra-list-component">
    <h2 v-if="extraReviews.length > 0">
      {{ $tc("ETAB.PAGES.SURVEY.@REVIEW_TITLE", extraReviews.length) }}
    </h2>
    <section>
      <ReviewCard v-for="review in extraReviews" :key="review.getUniqueId()" :review="review" />
    </section>
  </div>
</template>

<script>
import ReviewCard from "@etab/components/survey/ReviewCard.component.vue";

export default {
  components: {
    ReviewCard,
  },
  props: {
    extraReviews: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.review-extra-list-component {
  h2 {
    margin: 15px;
    color: $secondary;
  }

  > section {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    > *:first-of-type {
      margin-top: -25px; // make the first child higher in order to aknowledge the avatar translateY
    }
  }
}
</style>
